"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _Loader = _interopRequireDefault(require("@insided/shared/uikit/Loader"));

var _classnames = _interopRequireDefault(require("classnames"));

var _assets = _interopRequireDefault(require("@insided/deprecated-preact-components/assets"));

var _excluded = ["disabled", "fullWidth", "className", "icon", "endIcon", "noMargin", "startIcon", "oldStyle", "onClick", "IconProps", "title", "variant", "isLoading", "outlined", "type", "size", "id", "imageUrl", "children", "customSpanStyle", "buttonRef"];
var DEFAULT_ICON_PROPS = {
  size: 16
};

var hasChildren = function hasChildren(children) {
  if (!children) {
    return false;
  } // for some reason Preact puts an empty array for children
  // [Preact X] Check the behavior


  if (Array.isArray(children) && children.length === 0) {
    return false;
  }

  return true;
};
/**
 * This Button, ex. ButtonControl has no `"newStyle"` property, since it's "new" by default.
 */


var Button = function Button(_ref) {
  var _classNames;

  var disabled = _ref.disabled,
      fullWidth = _ref.fullWidth,
      className = _ref.className,
      icon = _ref.icon,
      endIcon = _ref.endIcon,
      noMargin = _ref.noMargin,
      startIcon = _ref.startIcon,
      oldStyle = _ref.oldStyle,
      onClick = _ref.onClick,
      _ref$IconProps = _ref.IconProps,
      IconProps = _ref$IconProps === void 0 ? DEFAULT_ICON_PROPS : _ref$IconProps,
      title = _ref.title,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'secondary' : _ref$variant,
      isLoading = _ref.isLoading,
      outlined = _ref.outlined,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'small' : _ref$size,
      id = _ref.id,
      imageUrl = _ref.imageUrl,
      children = _ref.children,
      _ref$customSpanStyle = _ref.customSpanStyle,
      customSpanStyle = _ref$customSpanStyle === void 0 ? undefined : _ref$customSpanStyle,
      buttonRef = _ref.buttonRef,
      restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  if (!icon && !title && !children) {
    return null;
  }

  return (0, _preact.h)("button", (0, _extends2.default)({
    ref: buttonRef,
    className: oldStyle ? className : (0, _classnames.default)(className, 'button-control-new', "button-control-new--".concat(size), (_classNames = {}, (0, _defineProperty2.default)(_classNames, "button-control-new--".concat(variant), !outlined), (0, _defineProperty2.default)(_classNames, "button-control-new--".concat(variant, "--outlined"), outlined), (0, _defineProperty2.default)(_classNames, 'button-control-new--no-margin', noMargin), (0, _defineProperty2.default)(_classNames, 'button-control-new--full-width', fullWidth), (0, _defineProperty2.default)(_classNames, 'button-control-new--icon', icon), (0, _defineProperty2.default)(_classNames, 'button-control-new--endIcon', endIcon), (0, _defineProperty2.default)(_classNames, 'button-control-new--startIcon', startIcon), _classNames)),
    id: id,
    disabled: disabled,
    onClick: onClick,
    title: hasChildren(children) && typeof title === 'string' ? title : undefined,
    type: type
  }, restProps), isLoading ? (0, _preact.h)("div", null, (0, _preact.h)(_Loader.default, null), (0, _preact.h)("span", {
    className: "button-control__title--hide"
  }, hasChildren(children) ? children : title)) : (0, _preact.h)("div", null, startIcon && (typeof startIcon === 'string' ? (0, _preact.h)(_assets.default, (0, _extends2.default)({
    icon: startIcon
  }, IconProps)) : startIcon), icon && (typeof icon === 'string' ? (0, _preact.h)(_assets.default, (0, _extends2.default)({
    icon: icon
  }, IconProps)) : icon), hasChildren(children) ? children : (0, _preact.h)("div", null, imageUrl && (0, _preact.h)("img", {
    src: (0, _absoluteUrlRuntime.resolveUrl)(imageUrl),
    className: "button-control__title-image",
    alt: ""
  }), (0, _preact.h)("span", {
    className: "button-control__title-text",
    style: customSpanStyle
  }, title)), endIcon && (typeof endIcon === 'string' ? (0, _preact.h)(_assets.default, (0, _extends2.default)({
    icon: endIcon
  }, IconProps)) : endIcon)));
};

var _default = Button;
exports.default = _default;